exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-modal-top-seven {\n  display: block;\n}\nfi-modal-top-seven .fi-dialog .fi-dialog-content {\n  font-size: 12px;\n}\nfi-modal-top-seven .fi-dialog .fi-dialog-content p strong {\n  font-weight: 600;\n}\nfi-modal-top-seven .fi-dialog .fi-dialog-content ul.dot-list {\n  padding: 0;\n  margin: 0;\n  list-style: inside;\n  font-size: 12px;\n}\nfi-modal-top-seven .fi-dialog .fi-dialog-content ul.dot-list li {\n  color: #09aa89;\n}\nfi-modal-top-seven .fi-dialog .fi-dialog-content ul.dot-list li span {\n  color: rgba(0, 0, 0, 0.87);\n}", ""]);

// exports
